import { Component } from '@angular/core'

@Component({
  selector: 'kdgh-page-entity-type',
  templateUrl: './page-entity-type.component.html',
  styleUrls: ['./page-entity-type.component.scss'],
})
export class PageEntityTypeComponent {}
